import React, { useMemo } from 'react';

import { BrazilStates } from '../../../Utils/BrasilStates';

import Select from '../../Select';

const StateInput = ({
  width,
  disabled,
  value,
  setValue,
  userData,
  validate,
  valid,
  isErrorApiCep,
}) => {
  const states = useMemo(() => {
    const statesMapped = BrazilStates.map((state) => ({
      value: state?.sigla,
      label: state?.nome,
    }));

    return statesMapped;
  }, [BrazilStates]);

  return (
    <Select
      id='Estado'
      labelName={'Estado'}
      size={width}
      disabled={disabled}
      optionsArray={states}
      value={value}
      marginTop={0}
      onBlur={validate}
      isError={valid === false && isErrorApiCep}
      errorMessage={'Selecione um estado'}
      title={'Selecione um estado'}
      handleSelectChange={(value) => {
        setValue({
          ...userData,
          Enderecos: [
            {
              ...userData.Enderecos[0],
              Estado: value,
            },
          ],
        });
      }}
    />
  );
};

export default StateInput;
